import { useState, useCallback, useEffect } from 'react';
import { modifiersListener } from '~/firebase/listeners/modifier';

import { CollectionSnapShotFn } from '~/firebase/listeners/type';
import { Modifier, ModifierWithId } from '~/types/store/modifier';

export default function useStoreModifiers(storeId: string) {
  const [modifiersMap, setModifiersMap] = useState<Map<string, ModifierWithId>>(new Map());

  const handleModifiersSnapshot = useCallback<CollectionSnapShotFn>(
    (snap) => {
      setModifiersMap(
        snap.docs.reduce<Map<string, ModifierWithId>>((acc, doc) => {
          const modifier = doc.data() as Modifier;

          acc.set(doc.id, { id: doc.id, ...modifier });

          return acc;
        }, new Map()),
      );
    },
    [setModifiersMap],
  );

  useEffect(() => {
    const unlisten = modifiersListener(storeId, handleModifiersSnapshot);

    return () => {
      unlisten();
    };
  }, [storeId]);

  return modifiersMap;
}
